// extracted by mini-css-extract-plugin
module.exports = {"pink600":"#ff7ab9"};